import { ComponentNameEnum, DropdownOption } from '@/types';

const getSpmSocialIconsFieldConfigV4 = (iconList: string[] = [], defaultValue = '') => ({
  componentName: ComponentNameEnum.SOCIAL_ICONS_STYLE_V4,
  options: {
    list: iconList.reduce((acc: DropdownOption[], current) => {
      acc.push({
        label: '',
        value: current,
      });
      return acc;
    }, []),
    defaultValue,
  },
});

export default getSpmSocialIconsFieldConfigV4;
